var deviceInfo;
function parseIntWithDefault(numberString) {
    var result = parseInt(numberString);
    return isNaN(result) ? 0 : result;
}
export function getDeviceInfo() {
    if (deviceInfo) {
        return deviceInfo;
    }
    var loweredUserAgentString = window.navigator.userAgent.toLowerCase();
    var platform = {
        keyword: 'Other',
        platformType: "Other" /* Other */,
    };
    [
        { keyword: 'Windows NT', platformType: "PC" /* PC */ },
        { keyword: 'Windows XP', platformType: "PC" /* PC */ },
        { keyword: 'Macintosh', platformType: "Mac" /* Mac */ },
        {
            keyword: 'Windows Phone',
            platformType: "WindowsPhone" /* WindowsPhone */,
            pageName: 'windows-phone',
        },
        { keyword: 'iPad', platformType: "iPad" /* iPad */, pageName: 'ipad' },
        {
            keyword: 'iPhone',
            platformType: "iPhone" /* iPhone */,
            pageName: 'iphone',
        },
        {
            keyword: 'Android',
            platformType: "AndroidPhone" /* AndroidPhone */,
            pageName: 'android-phone',
        },
        { keyword: 'Linux', platformType: "Linux" /* Linux */ },
        { keyword: 'CrOS', platformType: "Chromebook" /* Chromebook */ },
    ].some(function (value) {
        if (loweredUserAgentString.indexOf(value.keyword.toLowerCase()) !== -1) {
            platform = value;
            return true;
        }
        return false;
    });
    // Can't use keyword alone to distinguish between Android Phone and Android tablet
    if (platform.platformType === "AndroidPhone" /* AndroidPhone */ &&
        loweredUserAgentString.indexOf('mobile') === -1) {
        platform = {
            keyword: 'Android',
            platformType: "AndroidTablet" /* AndroidTablet */,
            pageName: 'android-tablet',
        };
    }
    var version = { major: 0, minor: 0, build: 0 };
    if (platform.platformType === "Mac" /* Mac */) {
        // This is to extract the Mac OS version, e.g.
        // Mozilla/5.0 (Macintosh; Intel Mac OS X 10_10_1) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/41.0.2227.1 Safari/537.36
        // Mozilla/5.0 (Macintosh; Intel Mac OS X 10.6; rv:25.0) Gecko/20100101 Firefox/25.0
        var match = /Mac OS X (\d+)(_|\.)(\d+)([_\.]?)(\d*)/i.exec(window.navigator.userAgent);
        if (match && match.length >= 6) {
            version = {
                major: parseIntWithDefault(match[1]),
                minor: parseIntWithDefault(match[3]),
                build: parseIntWithDefault(match[5]),
            };
        }
    }
    else if (platform.platformType === "PC" /* PC */ ||
        platform.platformType === "WindowsPhone" /* WindowsPhone */) {
        if (loweredUserAgentString.indexOf('windows xp') !== -1) {
            // XP shows up as either just xp or nt 5.1
            version = { major: 5, minor: 1, build: 0 };
        }
        else {
            // This is to extract the Windows version, e.g.
            // Mozilla/5.0 (Windows NT 10.0; <64-bit tags>) AppleWebKit/<WebKit Rev> (KHTML, like Gecko) Chrome/<Chrome Rev> Safari/<WebKit Rev> Edge/<EdgeHTML Rev>.<Windows Build>
            // Mozilla/5.0 (Windows Phone 10.0; Android <Android Version>; <Device Manufacturer>; <Device Model>) AppleWebKit/<WebKit Rev> (KHTML, like Gecko) Chrome/<Chrome Rev> Mobile Safari/<WebKit Rev> Edge/<EdgeHTML Rev>.<Windows Build>
            var match = /Windows (NT|Phone) (OS )?(\d+)\.(\d+)/i.exec(window.navigator.userAgent);
            if (match && match.length >= 5) {
                version = {
                    major: parseIntWithDefault(match[3]),
                    minor: parseIntWithDefault(match[4]),
                    build: 0,
                };
            }
        }
    }
    else if (platform.platformType === "iPad" /* iPad */ ||
        platform.platformType === "iPhone" /* iPhone */) {
        var match = loweredUserAgentString.match(/os (\d+)_(\d+)(_(\d+))?/);
        var major = parseIntWithDefault(match && match[1]);
        var minor = parseIntWithDefault(match && match[2]);
        var build = parseIntWithDefault(match && match[4]);
        version = { major: major, minor: minor, build: build };
    }
    var browser = {
        keyword: 'Other',
        browserType: "Other" /* Other */,
    };
    [
        { keyword: 'PhantomJS', browserType: "Headless" /* Headless */ },
        { keyword: 'Edge', browserType: "Edge" /* Edge */ },
        { keyword: 'MSIE', browserType: "IE" /* IE */ },
        { keyword: 'Edg', browserType: "EdgeChromium" /* EdgeChromium */ },
        { keyword: 'Chrome', browserType: "Chrome" /* Chrome */ },
        { keyword: 'CriOS', browserType: "Chrome" /* Chrome */ },
        { keyword: 'Firefox', browserType: "Firefox" /* Firefox */ },
        { keyword: 'Safari', browserType: "Safari" /* Safari */ },
    ].some(function (value) {
        if (loweredUserAgentString.indexOf(value.keyword.toLowerCase()) !== -1) {
            browser = value;
            return true;
        }
        return false;
    });
    deviceInfo = {
        platform: platform,
        platformVersion: version,
        browser: browser,
    };
    return deviceInfo;
}
//# sourceMappingURL=getDeviceInfo.js.map